export default __webpack_public_path__ + "static/media/codepen.9c6d9e9b.svg";